import { FC, ReactNode } from "react";
import {
  Stack,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  StyleProps,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import sid from "shortid";

interface Props {
  children: ReactNode;
  breadcrumb: {
    title: string;
    link: string;
  }[];
}

const CrudLayout: FC<Props & StyleProps> = ({
  breadcrumb,
  children,
  ...props
}) => {
  return (
    <Stack p={["1rem 1.5rem", "1rem 1.5rem"]} spacing="2" {...props}>
      <Breadcrumb
        spacing="8px"
        separator={<FaChevronRight color="gray.500" size="1.5rem" />}
        mb={["0", "0.5rem"]}
      >
        {breadcrumb.map((item, index) => (
          <BreadcrumbItem key={sid.generate()}>
            <BreadcrumbLink
              as={Link}
              to={item.link}
              isCurrentPage={index === breadcrumb.length - 1}
            >
              <Heading as="h2" fontSize={["xl", "3xl"]}>
                {item.title}
              </Heading>
            </BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
      <Box
        rounded="md"
        p="4"
        pb="8"
        background={useColorModeValue("white", "gray.900")}
        borderWidth="1px"
        borderColor={useColorModeValue("gray.200", "gray.700")}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default CrudLayout;
